import { ChatMessageTextInputProps } from './types';

export const ChatMessageTextInput = ({ onChatInputChange, onChatKeyDown, placeholder, maxLength, value }: ChatMessageTextInputProps) => {

    return (
        <textarea
            data-testid="textareaChatMsg"
            value={value}
            onChange={onChatInputChange}
            onKeyDown={onChatKeyDown}
            placeholder={placeholder}
            maxLength={maxLength}
            autoComplete="off"
            className="h-15 flex-1 min-w-0 bg-white rounded-l-lg rounded-r-none border-2 border-primary text-base leading-tight p-2 outline-hidden resize-none"
        />
    );
};
